import { ASSET_QUALITY } from '@shootsta/common-domain-data';

const { ORIGINAL, HD, SD } = ASSET_QUALITY;

export const LABELS_MAP = {
  [ORIGINAL]: 'Original Resolution',
  [HD]: 'High Resolution',
  [SD]: 'Low Resolution',
  CAPTION: 'Captions SRT',
  VTT_CAPTION: 'Captions VTT'
};